import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { getOptionsStore } from './../../store/Store';
import { SenderImageViewState } from 'mini-options-store';

/**
 * This action will get dispatched when user saves the sender image setting
 */
const saveSenderImageOption = action('saveSenderImageOption', () => {
    const store = getOptionsStore();
    const { isSenderImageEnabled } = store.activeViewState as SenderImageViewState;

    return addDatapointConfig({
        name: 'SaveSenderImageOption',
        customData: {
            SenderImage: isSenderImageEnabled ? 1 : 0,
        },
    });
});

export default saveSenderImageOption;
